<template>
  <div class="member-wrapper  common-bottom-space">
    <div class='content'>
      <van-cell v-for="(title,index) in listData" :key="index" :required="title.required">
        <h1>{{title.GroupSort}}、{{title.GroupName}}</h1>
        <div v-for="(item,index) in title.UserPreferenceItems" :key="index" class='field-item'>
          <van-radio-group v-if="item.Type==1&&!item.IsHidden" v-model="item.IsChosen" class='simulation-radio'>
            <van-button @click="agechange(item, title.UserPreferenceItems,title.GroupID)" :class="{'checked':item.IsChosen}" :key="item.Sort">{{item.PreferenceName}}</van-button>
          </van-radio-group>
          <div v-if="item.children.length > 0 && item.IsChosen" v-for="(itemC,index) in item.children" :key="index">
            <p>{{itemC.TipName}}：</p>
            <van-field class='s-field' v-model.trim="itemC.Value" maxlength=10></van-field><span class='s-span' v-if="title.GroupName==='去釉'">mm</span>
          </div>
          <van-field class='s-other' type="textarea" :rows="1" v-model.trim="item.Value" @focus="inputfocus(item)" maxlength="500" v-if="item.Type==2&&!item.IsHidden">{{item.PreferenceName}}</van-field>
        </div>
      </van-cell>
      <div class='common-btn-wrap'>
        <van-button type="info" round size="large" :disabled="saveDisabled" @click='handleSave'>保存</van-button>
      </div>
    </div>
  </div>
</template> 
<script>
import { Toast } from "vant";
export default {
  data () {
    return {
      listData: [],
      secondFieldShow: false,
      saveDisabled: false,
      arr: [],
    }
  },
  methods: {
    //初始化数据
    init () {
      var GetUserPreferences = {
        AppID: this.GLOBAL.AppID,
        Method: 'GetUserPreferences',
      };
      this.$Request(GetUserPreferences).then(res => {
        var arr = res.GroupPreferenceItems.map(item => {
          //必填项
          if (item.GroupID === 'aa24fcf4-deda-ff11-80bb-0f0204000000' || item.GroupID === 'ab24fcf4-deda-ff11-80bb-0f0204000000' || item.GroupID === 'ac24fcf4-deda-ff11-80bb-0f0204000000') {
            item.required = true
          }
          item.UserPreferenceItems = item.UserPreferenceItems
            .map(item => {
              item.children = []
              if (item.IsChosen) {
                item.IsChosenStr = item.Sort
              }
              return item
            })
            .map(itemC => {
              if (itemC.ParentID && itemC.ParentID !== "00000000-0000-0000-0000-000000000000") {
                if (_.find(item.UserPreferenceItems, { PreferenceID: itemC.ParentID })) {
                  _.find(item.UserPreferenceItems, { PreferenceID: itemC.ParentID }).children.push(itemC)
                }
              } else {
                return itemC
              }
            }).filter(_ => _)
          return item
        })
        this.listData = arr
      })
    },
    // 单选切换
    agechange (row, UserPreferenceItems, GroupID) {
      if (row.IsChosen) {
        row.IsChosen = false;
      } else {
        row.IsChosen = true;
      }
      UserPreferenceItems = UserPreferenceItems.filter(item => item.PreferenceID != row.PreferenceID).forEach(itemC => {
        itemC.IsChosen = false
        if (UserPreferenceItems.children && UserPreferenceItems.children.length > 0) {
          row.children.forEach(item => {
            itemC.IsChosen = false
          })
        }
      });
    },
    inputfocus (item) {
      item.IsChosen = true
    },

    // 保存
    handleSave () {
      this.saveDisabled = true;
      let postarr = []
      this.listData.forEach(item => {
        item.UserPreferenceItems.forEach(itemC => {
          if (itemC.IsChosen) {
            if (itemC.children == 0) {
              postarr.push({
                PreferenceGroupID: item.GroupID,
                ChosenList: [{
                  'PreferenceID': itemC.PreferenceID,
                  'value': itemC.Value
                }]
              })
            } else {
              let childrenListValue = ''
              let arr = []
              itemC.children.forEach(item => {
                childrenListValue = item.Value.concat()
                arr.push(
                  {
                    'PreferenceID': item.PreferenceID,
                    'value': item.Value
                  },
                  {
                    'PreferenceID': itemC.PreferenceID,
                    'value': itemC.Value
                  }
                )
              })
              postarr.push({
                PreferenceGroupID: item.GroupID,
                ChosenList: arr
              })
            }
          }
        })
      })
      //校验
      if (this.checkFieldValid(postarr)) {
        Toast.loading({
          duration: 0,
          message: '正在保存...',
          overlay: true
        });
        var AddUpdateUserPreferences = {
          AppID: this.GLOBAL.AppID,
          Method: 'AddUpdateUserPreferences',
          UserPreferencesJson: JSON.stringify(postarr),//临床偏好:[{"PreferenceGroupID":"xxxxx","ChoosenList":[{"PreferenceID":"yyyy", value:"zzzzzzz"}]}] 
        };
        this.$Request(AddUpdateUserPreferences).then(res => {
          Toast.clear();
          Toast.success({
            duration: 1000,
            message: '保存成功'
          });
          setTimeout(() => {
            this.saveDisabled = false;
            this.$router.push({ path: '/setting-page', replace: true })
          }, 1000)
        }, err => {
          setTimeout(() => {
            Toast.clear();
            this.saveDisabled = false;
          }, 3000)
        })
      } else {
        this.saveDisabled = false;
      }
    },
    //校验拔牙、去釉、接受种植必填项
    checkFieldValid (data) {
      let checkItem1 = _.find(data, { PreferenceGroupID: 'aa24fcf4-deda-ff11-80bb-0f0204000000' })
      let checkItem2 = _.find(data, { PreferenceGroupID: 'ab24fcf4-deda-ff11-80bb-0f0204000000' })
      let checkItem3 = _.find(data, { PreferenceGroupID: 'ac24fcf4-deda-ff11-80bb-0f0204000000' })
      if (!checkItem1) {
        Toast.fail({ duration: 3000, message: '请选择是否接受拔牙' })
        return false
      } else if (!checkItem2) {
        Toast.fail({ duration: 3000, message: '请选择是否首选去釉' })
        return false
      } else if (!checkItem3) {
        Toast.fail({ duration: 3000, message: '请选择是否接受种植支抗钉' })
        return false
      }
      return true
    },
    show (list) {
      list.UserPreferenceItems[0].IsHidden = !list.UserPreferenceItems[0].IsHidden
      list.UserPreferenceItems[0].IsChosen = !list.UserPreferenceItems[0].IsChosen
    },
  },
  created () {
    this.init();
  }
}
</script>
<style lang="less" scoped>
@import "./common/common.less";
.content {
  padding: 20px;
  .simulation-radio {
    margin-right: 20px;
    margin-bottom: 20px;
    button {
      font-size: 28px;
      height: unset;
      line-height: unset;
      padding: 5px 20px;
    }
    &.checked {
      background: @blue;
      span {
        color: #ffffff;
      }
    }
  }
  .field-item {
    overflow: hidden;
    margin: 10px 0;
  }
  p {
    padding: 10px 0;
  }
  .s-span {
    line-height: 60px;
    height: 50px;
    display: block;
    float: left;
    margin-left: 20px;
  }
  .s-field {
    float: left;
    border: 1px solid #ddd;
    width: 200px;
    padding: 10px 8px;
    input {
      width: 100%;
    }
  }
  .s-other {
    width: 600px;
    border: 1px solid #ddd;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/member/clinic-preference.vue